import { render, staticRenderFns } from "./equipment-details-modal.vue?vue&type=template&id=370a894a&scoped=true&"
import script from "./equipment-details-modal.vue?vue&type=script&lang=ts&"
export * from "./equipment-details-modal.vue?vue&type=script&lang=ts&"
import style0 from "./equipment-details-modal.vue?vue&type=style&index=0&id=370a894a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a894a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VIcon,VRow})
